<ngb-accordion id="ngba" [closeOthers]="true" [activeIds]="[]">

  <ngb-panel *ngFor="let accordionItem of accordionItems" [id]="accordionItem.id">
    <ng-template ngbPanelTitle>
      <div class="accordion-title-container">
        <img [src]="accordionItem?.iconPath ? accordionItem?.iconPath : assetsPath+'/svg/about.svg'">
        <span class="accordion-title">{{accordionItem?.title}}</span>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <div *ngIf="accordionItem?.isInnerHTML" [innerHTML]="accordionItem?.content"></div>
      <ng-container *ngIf="!accordionItem?.isInnerHTML" >
        {{accordionItem?.content}}
      </ng-container>
    </ng-template>
  </ngb-panel>
</ngb-accordion>